import type { TargetedEvent, VNode } from 'preact';

import { setSort } from 'Core/actions/request';
import { useDispatch, useSelector } from 'Core/store';
import uiConfig from 'Models/uiConfig/uiConfig';
import t from 'Utils/translate';

interface Props {
  className?: string;
}

export default function SortSelect({ className }: Props): VNode<object> {
  const dispatch = useDispatch();
  const sort = useSelector((state) => state.search.request.sort);

  const onChange = (e: TargetedEvent<HTMLSelectElement, Event>) => dispatch(setSort(e.currentTarget.value));

  const props = {
    className,
    onChange,
    value: sort,
  };

  return (
    <select {...props} aria-label="Sort by">
      {uiConfig.sortFields?.map((sortField) => (
        <option value={sortField} key={sortField}>
          {t(`sort_option_${sortField.replace(':', '_')}`)}
        </option>
      ))}
    </select>
  );
}
